import { DropdownOption } from '@mayoral/ui';
import { seasonToLabel } from '@utils/season';
import { TFunction } from 'next-i18next';

import { Navigation, NavigationSection } from '@/types/app-config';
import { Season } from '@/types/global';

/**
 * Finds the active section based on the href.
 */
export const findSelectedSection = (
  matchingHref: string,
  navigation: Navigation,
): NavigationSection => {
  if (!navigation) {
    return null;
  }

  return navigation.find(({ items }) => items.some(({ href }) => matchingHref.startsWith(href)));
};

/**
 * Converts seasons into dropdown options
 */
export const seasonsToOptions = (seasons: Season[], t: TFunction): DropdownOption[] => {
  if (!seasons) {
    return [];
  }
  return seasons.map((item) => ({
    label: seasonToLabel(item.label, t),
    value: String(item.value),
  }));
};
